// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__QEzr1","inner":"Footer_inner__32Z3Q","nextIcon":"Footer_nextIcon__22wqS","innerLeft":"Footer_innerLeft___Pgzh"};